/**
 * Short Web Audio tones — admin (brighter double ping) vs member (softer chime).
 * No external assets; works after a user gesture on some browsers for first play.
 */

export const STAFF_SOUND_PREF = 'staff_notif_sound_pref';
export const MEMBER_SOUND_PREF = 'member_notif_sound_pref';

/** @returns {boolean|null} true / false / null if user has not chosen yet */
export function getSoundPreference(prefKey) {
  try {
    const v = localStorage.getItem(prefKey);
    if (v === '1' || v === 'true') return true;
    if (v === '0' || v === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

export function setSoundPreference(prefKey, enabled) {
  try {
    localStorage.setItem(prefKey, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
}

function playTone(freq, startAt, duration, gain = 0.12) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(freq, ctx.currentTime + startAt);
    g.gain.setValueAtTime(0, ctx.currentTime + startAt);
    g.gain.linearRampToValueAtTime(gain, ctx.currentTime + startAt + 0.02);
    g.gain.linearRampToValueAtTime(0.001, ctx.currentTime + startAt + duration);
    o.connect(g);
    g.connect(ctx.destination);
    o.start(ctx.currentTime + startAt);
    o.stop(ctx.currentTime + startAt + duration + 0.05);
    setTimeout(() => ctx.close().catch(() => {}), (startAt + duration + 0.1) * 1000);
  } catch {
    /* ignore */
  }
}

/** Staff / admin: crisp two-note alert */
export function playAdminNotificationSound() {
  playTone(880, 0, 0.12, 0.14);
  playTone(1174, 0.14, 0.14, 0.11);
}

/** Member portal: warmer two-note chime */
export function playMemberNotificationSound() {
  playTone(523, 0, 0.18, 0.1);
  playTone(659, 0.16, 0.2, 0.09);
}
